var exhaustiveCheck = function (value) { return value; };

export { exhaustiveCheck };
